import styled from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const Trigger = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.sizes.controlHeight};
  height: ${({ theme }) => theme.sizes.controlHeight};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.pill};
  background: transparent;
  color: ${({ theme }) => theme.colors.fg1};
  cursor: pointer;
  transition: border-color ${({ theme }) => theme.motion.durationFast} ${({ theme }) => theme.motion.easeOut};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:focus-visible {
    outline: ${({ theme }) => theme.sizes.focusOutline} solid ${({ theme }) => theme.colors.primary};
    outline-offset: ${({ theme }) => theme.sizes.focusOutlineOffset};
  }
`;

/** The solid count of the design system (`CountBadge`), on the bell's corner. */
export const BadgeSpot = styled.span`
  position: absolute;
  top: calc(${({ theme }) => theme.spacing[1]} * -1);
  right: calc(${({ theme }) => theme.spacing[1]} * -1);
  pointer-events: none;
`;

export const Panel = styled.div`
  position: absolute;
  top: calc(100% + ${({ theme }) => theme.spacing[2]});
  right: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  width: min(${({ theme }) => theme.sizes.panelWidth}, calc(100vw - ${({ theme }) => theme.spacing[8]}));
  max-height: 70vh;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.lg};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.shadows.card};
`;

export const PanelHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => theme.spacing[3]} ${({ theme }) => theme.spacing[4]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const Title = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fs.body};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.fg1};
`;

export const List = styled.ul`
  flex: 1;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
`;

export const Item = styled.button<{ $unread: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
  width: 100%;
  padding: ${({ theme }) => theme.spacing[3]} ${({ theme }) => theme.spacing[4]};
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme, $unread }) => ($unread ? theme.colors.tintOrange50 : "transparent")};
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.gray50};
  }

  &:focus-visible {
    outline: ${({ theme }) => theme.sizes.focusOutline} solid ${({ theme }) => theme.colors.primary};
    outline-offset: calc(${({ theme }) => theme.sizes.focusOutline} * -1);
  }
`;

export const ItemTitle = styled.span<{ $unread: boolean }>`
  font-size: ${({ theme }) => theme.typography.fs.sm};
  font-weight: ${({ $unread }) => ($unread ? 700 : 500)};
  color: ${({ theme }) => theme.colors.fg1};
`;

export const ItemAge = styled.span`
  font-size: ${({ theme }) => theme.typography.fs.xs};
  color: ${({ theme }) => theme.colors.fg2};
`;

export const Empty = styled.p`
  margin: 0;
  padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[4]};
  font-size: ${({ theme }) => theme.typography.fs.sm};
  color: ${({ theme }) => theme.colors.fg2};
  text-align: center;
`;
